import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "@redux-saga/core";

import reducer from "./redux";
import saga from "./saga";
import { saveState } from "../container/SportsBookNode/utils/common/functions";
import { initialState as betslipInitialState } from "../sportbookNode-saga/redux/betslip/initialState";
import Session from "../utils/session";

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({ thunk: false, serializableCheck: false }),
    sagaMiddleware
  ],
  devTools: process.env.NODE_ENV !== "production",
  preloadedState: {
    sportbook: {
      languages: {
        language: Session.getLanguage
      }
    },
    authentication: {
      isLoggedIn: !!Session.getSessionCred,
      userId: Session.getSessionCred?.userId
    }
  }
});

store.subscribe(() => {
  const state = store.getState();

  setTimeout(() => {
    saveState({
      sportbook: {
        betslip: {
          ...betslipInitialState,
          ...state.sportbook.betslip
        }
      }
    });
  }, 2000);
});
sagaMiddleware.run(saga);

export default store;

/**
 * @typedef {ReturnType<typeof reducer>} RootState
 */
